import API from './api.js'
import store from './store.js'

import * as error from './error/actions.js'
import * as templates from './templates/actions.js'
import * as folders from './folders/actions.js'
import * as locale from './locale/actions.js'
import * as login from './login/actions.js'
import * as progress from './progress/actions.js'
import * as save from './save/actions.js'
import * as selected from './selected/actions.js'
import * as siteitem from './siteitem/actions.js'

const redux = {
  store,
  actions: {
    error,
    folders,
    locale,
    login,
    progress,
    save,
    selected,
    siteitem,
    templates
  }
}

export const api = API
export default redux
